const localStorageKey = {
    updateDone: "updateDone",
    userId: "userId",
    autoSync: "auto_sync",
    formId: "formId",
    lastUpdate: "last_update",
    attempToSaveForm: "attempToSaveForm",
    isLoggedIn: "isLoggedIn",
    alreadyLoad: "alreadyLoad",
    formSubmitted: "formSubmitted",
    serverDate: "serverDate",
    currentLanguage: "i18nextLng",
    lastSyncDate: "lastSyncDate"
}

const event = {
    selectAutoCompleteOption: "selectAutoCompleteOption",
    renderReport: "renderReport",
    closeSummary: "closeSummary",
    formSubmit: "formSubmit",
    errorSubmission: "errorSubmission",
    showSummary: "showSummary",
    goToSpecificStep: "goToSpecificStep",
    updateCompleted: "updateCompleted",
    resetOperation: "resetOperation"
}

export {
    localStorageKey,
    event
}